import httpUtil from '@/utils/axios'

export class RepairAPI {
  static async submitPublic(payload) {
    return httpUtil.post('/repairs/public/submit', payload)
  }

  static async getRepairList(params = {}) {
    return httpUtil.get('/repairs', params)
  }

  static async getAssignedToMe() {
    return httpUtil.get('/repairs/assigned-to-me')
  }

  static async getStatistics() {
    const list = await httpUtil.get('/repairs')
    const rows = Array.isArray(list) ? list : []
    return {
      total: rows.length,
      pending: rows.filter(item => item.status === 'PENDING').length,
      processing: rows.filter(item => item.status === 'PROCESSING').length,
      completed: rows.filter(item => item.status === 'COMPLETED' || item.status === 'CLOSED').length,
      cancelled: rows.filter(item => item.status === 'CANCELLED').length
    }
  }

  static async getRepairDetail(repairId) {
    return httpUtil.get(`/repairs/${repairId}`)
  }

  static async deleteById(repairId) {
    return httpUtil.delete(`/repairs/${repairId}`)
  }

  static async createRepair(repairData) {
    return httpUtil.post('/repairs', repairData)
  }

  static async getLogs(repairId) {
    return httpUtil.get(`/repairs/${repairId}/logs`)
  }

  static async getPartReplacements(repairId) {
    return httpUtil.get(`/repairs/${repairId}/part-replacements`)
  }

  static async addPartReplacement(repairId, payload) {
    return httpUtil.post(`/repairs/${repairId}/part-replacements`, payload)
  }

  static async getFollowups(repairId) {
    return httpUtil.get(`/repairs/${repairId}/followups`)
  }

  static async addFollowup(repairId, payload) {
    return httpUtil.post(`/repairs/${repairId}/followups`, payload)
  }

  static async exportExcel() {
    return httpUtil.download('/repairs/export/excel', 'repair_tickets.xlsx')
  }

  static async downloadImportTemplate() {
    return httpUtil.download('/repairs/template', 'repair_ticket_import_template.xlsx')
  }

  static async importExcel(file, onProgress) {
    return httpUtil.upload('/repairs/import', file, onProgress)
  }

  static async updateRepairStatus(repairId, newStatus, assignedTo = null) {
    if (assignedTo) {
      await httpUtil.put(`/repairs/${repairId}/assign/${assignedTo}`)
    }
    return httpUtil.put(`/repairs/${repairId}/status`, {}, { params: { status: newStatus } })
  }

  static async addNotes(repairId, notes) {
    return httpUtil.put(`/repairs/${repairId}/notes`, {}, { params: { notes } })
  }
}

export const repairAPI = RepairAPI
